module.exports = __webpack_public_path__ + "img/GYLFW_3.7bdbb7e9.jpg";